export default {
  HTML: "text/html",
  PLAINTEXT: "text/plain",
  AEON_TABLE: "aeon/table",
  AEON_ITEMS: "aeon/items"
};
